import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-license',
  templateUrl: './license.component.html',
  styleUrls: ['./license.component.css'],
  animations: [
    trigger('openMenu', [
      state('open', style({
        overflow: 'hidden',
      })),
      state('close', style({
        padding: '0px',
        margin: '0px',
        overflow: 'hidden',
        height: '0px',
        display: 'none',
      })),
      transition('open => close', [
        animate(280, style({ padding: '0px', margin: '0px', height: '0px', transition: 'ease' })),
      ]),
      transition('close => open', [
        animate(280, style({  })),
      ]),
      state('openArrow', style({
        transform: 'rotate(180deg)',
      })),
      state('closeArrow', style({
        transform: 'rotate(0)',
      })),
      transition('openArrow => closeArrow', [
        animate(600, style({ transform: 'rotate(0)', transition: 'ease-in' })),
      ]),
      transition('closeArrow => openArrow', [
        animate(600, style({ transform: 'rotate(180deg)', transition: 'ease-out' })),
      ]),
    ]),
  ],
})
export class LicenseComponent implements OnInit {
  show0 = true;
  show1 = true;
  constructor() { }

  ngOnInit(): void {
  }

  toggle(id: number) {
    switch (id) {
      case 0: {
        this.show0 = !this.show0;
        break;
      }
      case 1: {
        this.show1 = !this.show1;
        break;
      }
      default:
        break;
    }
  }

  get menuState() {
    return this.show0 ? 'open' : 'close';
  }

  get arrowState() {
    return this.show0 ? 'openArrow' : 'closeArrow';
  }
}
